export const MODES_DRAG = "drag";
export const MODES_REMOVE = "remove";
export const MODES_PREVIEW = "preview";
export const MODES_SELECT_PREVIEW = "selectPreview";
